import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { PHBHPFeaturePackageSOPManagementService } from '../ph-bhp-feature-package-sopmanagement.service';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { HandDisinfectionIndicators, SopDetail, SopStep } from '../Models';
import { PhBhpSopStepComponent } from '../ph-bhp-sop-step/ph-bhp-sop-step.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { sop, stepCards } from './sop';
import { PhBhpPreviewSOPComponent } from '../ph-bhp-preview-sop/ph-bhp-preview-sop.component';
import { PhBhpViewSOPComponent } from '../ph-bhp-view-sop/ph-bhp-view-sop.component';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Subject } from 'rxjs';
import { openTranslationModal } from '../translation.utilities';
import { ChangedTranslationValue } from '../dynamic-translation-dialog/dynamic-translation-dialog.component';
import { StepsVersions } from '../Models/StepsVersions';
import { Router } from '@angular/router';
import { Step, StepIndications, SubProcess } from "./step-editor/step-editor.component";
import { LoggingService } from 'src/app/services/logging.service';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-manage-sop',
  templateUrl: './ph-bhp-manage-sop.component.html',
  styleUrls: ['./ph-bhp-manage-sop.component.css']
})

export class PhBhpManageSOPComponent implements OnInit, OnChanges {
  /**
   * Index of the sop Step that was selected / opened last (when opening the sop step editor).
   * If null, no step is currently selected / open.
   */
  lastSelectedStepIndex?: number = null;

  /**
   * List of all sop steps.
   */
  sopStepsList: Array<SopStep> = [];

  // TODO this can sometimes contain "invalid" data, e.g. after deleting a step. Consider representing these states in the type directly, e.g. by making sopStep optional / allowing 'undefined'.
  /**
   * The currently selected step (used e.g. in PhBhpSopStepComponent).
   */
  sopStep: SopStep = sop();

  updateSubmitted = false;
  sopDetails: SopDetail = {} as SopDetail;
  handDisinfectionIndicators: Array<HandDisinfectionIndicators>;
  @ViewChild('modelSopDescription') modelSopDescription;
  @ViewChild('modelSopTitle') modelSopTitle;
  @ViewChild('disclaimerModal') disclaimerModal: TemplateRef<any>;
  @ViewChild('cancelmodal') cancelmodal: TemplateRef<any>;
  sopImageInvalid: boolean = false;
  /**
   * Id of the SOP to edit / view.
   */
  @Input() sopId: number;
  /**
   * Version of the SOP to edit / view.
   */
  @Input() sopVersionNo: number;
  /**
   * Information on the currently logged in user.
   * TODO could be injected from service instead?
   */
  @Input() userData: any;
  /**
   * List of all institutions that a user has access to.
   * TODO Consolidate: Possible duplication of `institutionList`
   */
  @Input() institutions;
  /**
   * Whether the application is opened on a 'desktop' device
   * TODO obsolete / unused?
   */
  @Input() isDesktop = true;
  /**
   * Whether the currently selected step is a subprocess / has substeps.
   */
  isSubprocess = false;
  /**
   * Flag used to ensure user data is only loaded / processed once.
   * False after the user data has been processed.
   *
   * Since the user data is passed via Input(), it is not guaranteed to be available in ngOnInit(), so
   * ngOnChanges() is used to process the user data once the value is set. `userFlag` is checked and toggled, so that
   * this is not accidentally done twice (since ngOnChanges() may be triggered on other changes as well).
   */
  userFlag = true;
  IAgree;
  /**
   * RoleId of the current user.
   */
  roleId: number;
  modelAgree = false;
  @Output() childData = new EventEmitter();
  countriesList: Array<any> = [];
  /**
   * List of all institutions that a user has access to.
   */
  institutionList: Array<any> = [];
  /**
   * Whether or not a institution is selected (used for validation)
   */
  institutionIsChecked = false;
  @ViewChild('sopStepComponent') sopStepComponent: PhBhpSopStepComponent;
  modalRef: BsModalRef;
  @ViewChild('delmodal') delmodal: TemplateRef<any>;
  sopCommentsMaxLength = 1000;
  sopdescriptionMaxLength = 1000;
  /**
   * Whether this SOP will also be available as puzzle
   * @private
   */
  IsSOPPuzzle: boolean;
  countryChecked: Object = {};
  submitted = false;
  checkUpdate = false;
  saveDebouncer: Subject<string> = new Subject<string>();
  translationKeys: typeof TranslationKeys = TranslationKeys;

  /**
   * All institutions by id that are active / selected for this SOP
   */
  checkedInstitutionIds = new Set<number>();
  previousImage: any = {};
  blockCAChanges: boolean = false;

  /**
   *
   */
  stepRef: any;

  /**
   * A reference to the element containing the step editor. This element is moved manually to align the popup with
   * the currently selected step.
   * TODO consider an alternative implementation, that does not rely on direct positioning in code
   */
  @ViewChild('stepEditorContainer') private stepEditorContainer: ElementRef<HTMLDivElement>;

  /**
   * A reference to the element of a small arrow, above the step editor, pointing to the step.
   * This element is moved manually to align the popup with the currently selected step.
   * TODO consider an alternative implementation, that does not rely on direct positioning in code
   */
  // @ViewChild('stepEditorArrow') private stepEditorArrow: ElementRef<HTMLSpanElement>;

  constructor(
    public service: PHBHPFeaturePackageSOPManagementService,
    public layoutService: PHBHPLayoutPackageService,
    private modalService: BsModalService,
    public translate: TranslateService,
    private router: Router,
    private logging: LoggingService
  ) {
  }

  /**
   * Helper to convert set to array for component communication
   */
  get checkedInstitutionIdsArray() {
    return Array.from(this.checkedInstitutionIds);
  }

  /**
   * Helper to convert currently selected step for component communication
   *
   * TODO Update step editor endpoints and replace this.sopStep for a improved data model to eliminate this converter.
   */
  get currentStep(): Step | SubProcess {
    if (this.sopStep.stepType) {
      return {
        title: this.sopStep.stepName,
        subSteps: this.sopStep.stepCards
          .map(sc => ({
            title: sc.stepTittle,
            imagePath: sc.stepImage,
            isHygieneRelevant: sc.hygieneRelevantStep,
            hasHandDisinfection: sc.handDisinfection,
            hasIndication1: sc.indications[1] === true,
            hasIndication2: sc.indications[2] === true,
            hasIndication3: sc.indications[3] === true,
            hasIndication4: sc.indications[4] === true,
            hasIndication5: sc.indications[5] === true,
            isSituational: sc.situational ? sc.comments : undefined,
            invalidTitle: sc.invalidTitle,
            invalidImage: sc.invalidImage

          })),
        useSubStepIndexAsDefaultImage: this.sopStep.useStepImage,
        stepRef: this.stepRef
      }
    } else {
      // if the type is false, this is a single step, so we use the first step card directly
      // TODO adjust backend endpoint to use a new cleaner data model.
      return {
        title: this.sopStep.stepName,
        imagePath: this.sopStep.stepCards[0].stepImage,
        isHygieneRelevant: this.sopStep.stepCards[0].hygieneRelevantStep,
        hasHandDisinfection: this.sopStep.stepCards[0].handDisinfection,
        hasIndication1: this.sopStep.stepCards[0].indications[1] === true,
        hasIndication2: this.sopStep.stepCards[0].indications[2] === true,
        hasIndication3: this.sopStep.stepCards[0].indications[3] === true,
        hasIndication4: this.sopStep.stepCards[0].indications[4] === true,
        hasIndication5: this.sopStep.stepCards[0].indications[5] === true,
        invalidTitle: this.sopStep.stepCards[0].invalidTitle,
        invalidImage: this.sopStep.stepCards[0].invalidImage,
        isSituational: this.sopStep.stepCards[0].situational ? this.sopStep.stepCards[0].comments : undefined,
        stepRef: this.stepRef
      }
    }

  }

  ngOnChanges() {
    if (this.userData && this.userFlag) {
      this.roleId = this.userData.roleName.roleId;
      this.userFlag = false;
      if (this.roleId === 1) {
        // this.sopDetails.accessType = 'Global';
        this.IsSOPPuzzle = true

        this.service.getSOPCountriesList().subscribe((res: Array<any>) => {
          this.countriesList = res;
        });
      } else {
        // this.sopDetails.accessType = 'Country';
        this.IsSOPPuzzle = this.sopDetails.isSOPPuzzle;

        this.service.getUsersInstitutions(this.userData.userId, this.roleId).subscribe((res) => {
          this.institutionList = res;
          if (this.institutionList && this.institutionList.length > 0) {
            const roleId = this.userData.roleName.roleId
            this.institutionList = this.institutionList.filter(inst => roleId > 2 ? inst.institution.institution.status : true);
            this.checkedInstitutionIds.clear();
            this.institutionList.forEach(inst => {
              if (this.sopDetails.sopInstitutions && this.sopDetails.sopInstitutions.some(x => x.institutionID == inst.institution.institution.institutionID)) {
                this.checkedInstitutionIds.add(inst.institution.institution.institutionID);
              }
            });
          }
        });
      }
    }
  }

  onAccessTypeChanged($event) {

  }

  sopImages: any;
  ngOnInit() {
    this.service.isCollapsed = false;
    this.roleId = this.userData.roleName.roleId;
    if (this.sopId) {
      this.layoutService.showLoader = true;
      this.loadTranslationsForSOP();
      let subSopsIds = this.service.getSOPById(this.sopId);
      let subVersionImages = this.service.getSopVersionsImages(this.sopId);
      
      forkJoin([subSopsIds,subVersionImages]).subscribe(([res, sopImages]) => {

          this.sopDetails = res;
          this.sopImages = sopImages;
          if (this.sopDetails.draftComments == "") {
            this.sopDetails.draftComments = `SOP_${this.sopId}_0.COMMENT`
          }

          this.blockCAChanges = false;
          if (this.roleId == 2 && res.createdBySA && res.type == 'Master') {
            this.blockCAChanges = true;
          }
          this.IsSOPPuzzle = this.sopDetails.isSOPPuzzle;
          if (this.sopDetails.sopInstitutions && this.sopDetails.sopInstitutions.institutionID) {
            const institutions = this.sopDetails.sopInstitutions.institutionID.split(',').map(id => parseInt(id));
            institutions.forEach(x => this.checkedInstitutionIds.add(x));
          }
          if (this.sopDetails.sopCountries && this.sopDetails.sopCountries.countryID) {
            const countries = this.sopDetails.sopCountries.countryID.split(',');
            countries.forEach(x => this.countryChecked[x] = true);
          }
          if (this.sopVersionNo != null) {
            // specific versionNo should be shown
            if (this.sopVersionNo === 0) {
              // show draft
              this.sopStepsList = JSON.parse(this.sopDetails.draftStepsJson);
              this.layoutService.showLoader = false;
            } else {
              const fixupKeys = (key: string): string => {
                const oldValue = `SOP_${this.sopId}_${this.sopVersionNo}.`;
                const replacementValue = `SOP_${this.sopId}_0.`;
                const newKey = key.replace(oldValue, replacementValue);

                this.translate.get(key)
                  .subscribe((value) => this.translate.set(newKey, value));

                return newKey;
              };

              const findMaxF = (a, f) => a.sort((l, r) => f(r) - f(l)).find(() => true);

              // find the published version
              const publishedVersion = findMaxF(this.sopDetails.sopStepsVersions, f => f.versionNo);

              // deep clone the published version
              const draftVersion: StepsVersions = JSON.parse(JSON.stringify(publishedVersion));

              // fixup all properties
              draftVersion.versionNo = 0;
              draftVersion.comments = fixupKeys(draftVersion.comments);
              this.sopDetails.title = fixupKeys(this.sopDetails.title);
              this.sopDetails.description = fixupKeys(this.sopDetails.description);

              const draftSteps: SopStep[] = JSON.parse(draftVersion.stepsJsonFile);
              draftSteps.forEach((step) => {
                step.stepName = fixupKeys(step.stepName);
                step.stepCards.forEach(card => {
                  card.stepTittle = fixupKeys(card.stepTittle);
                  card.comments = fixupKeys(card.comments);
                });
              });

              this.sopDetails.draftStepsJson = JSON.stringify(draftSteps);
              this.sopStepsList = draftSteps;
              this.checkedInstitutionIds = new Set<number>(this.sopDetails.sopInstitutions.map(x => x.institutionID));
              this.institutionList = this.sopDetails.sopInstitutions.map(x => ({ institution: { institution: x } }));
              this.saveSOP(() => {
                this.router.navigate([`/sop/edit/${this.sopId}/0`]);
                this.layoutService.showLoader = false;
                this.ngOnChanges();
              });

              // TODO handle invalid versionNo Input with error or fallback
            }

          } else if (this.sopDetails.draftStepsJson) {
            // no specific version was requested, but there is a draft
            this.sopStepsList = JSON.parse(this.sopDetails.draftStepsJson);
            this.layoutService.showLoader = false;
          } else if (this.sopDetails.sopStepsVersions[0].stepsJsonFile) {
            // no specific version was requested and no draft, show last version

            // find last / highest version
            let lastVersion = 0;
            for (const v of this.sopDetails.sopStepsVersions) {
              if (v.versionNo > lastVersion) {
                lastVersion = v.versionNo;
              }
            }

            this.sopStepsList = JSON.parse(this.sopDetails.sopStepsVersions[lastVersion].stepsJsonFile);
            this.sopDetails.draftComments = this.sopDetails.sopStepsVersions[lastVersion].comments;
            this.layoutService.showLoader = false;
          }
          this.isSubprocess = res.isSubStep;
          this.service.subStepDisable = res.isSubStep;
          this.sopDetails.sopImage = this.sopImages.find(x => x.versionNo == this.sopVersionNo)?.imageUrl;
          this.layoutService.showLoader = false;
        });
    } else if (this.sopStepsList.length === 0) {
      this.sopStepsList = [sop()];
    }
    this.service.getHandDisinfectionIndicators().subscribe((res: [HandDisinfectionIndicators]) => {
      this.handDisinfectionIndicators = res;
    });

    this.saveDebouncer
      .debounceTime(2000)
      .subscribe((value) => {
        this.saveSOP();
      });
  }

  publishSOP() {
    if (this.validateForPublish(this.sopDetails)) {
      this.modalRef = this.modalService.show(this.disclaimerModal, Object.assign({}, { class: 'w-420' }));
    } else {

    }
  }

  getTranslatedKeyLength(key) {
    var value = this.layoutService.translateText(key);
    return value?.length || 0;
  }

  async disclaimer() {
    this.modelAgree = false;
    if (!this.IAgree) {
      this.modelAgree = true;
      this.layoutService.showError(this.layoutService.translateText('SOP_MANAGEMENT.CLICK_AGREE'));
      return false;
    }
    this.modalRef.hide();
    this.sopDetails.draftStepsJson = JSON.stringify(this.sopStepsList);
    this.service.PublishSOP(this.sopId, this.userData.userId, this.sopDetails).subscribe((res) => {
      const query = this.translate.getLangs().map(l => `l=${l}`).join('&');

      this.refreshDynamicTranslations();

      this.service.getPublishedTranslation(this.sopId, query).subscribe((res: PublishedSopTranslation) => {
        for (const language in res) {
          for (const key in res[language]) {
            const value = res[language][key];
            this.translate.set(key, value, language);
          }
        }
      });
      this.childData.emit({ key: 'save' });
    });
  }

  validation(): [boolean, string] {
    this.updateSubmitted = false;
    this.institutionIsChecked = false;
    this.submitted = true;

    if (this.modelSopDescription.invalid) {
      this.updateSubmitted = true;
      return [false, 'Sop description is invalid'];
    }
    if (this.modelSopTitle.invalid) {
      this.updateSubmitted = true;
      return [false, 'Sop title is invalid'];
    }
    if (this.updateSubmitted) {
      return [false, 'Submitted update'];
    }

    return [true, ''];

  }

  // TODO refactor to async / Promise or Observable to allow proper error handling
  saveSOP(callback = () => {
  }) {
    this.layoutService.showLoader = true;
    this.resetValidations();
    const institutionsNewList = this.institutionList.filter(x => this.checkedInstitutionIds.has(x.institution.institution.institutionID))
      .map(x => ({
        sopId: this.sopId,
        institutionID: x.institution.institution.institutionID,
        institutionName: x.institution.institution.institutionName,
        createdBy: this.userData.userId,
      }));
    this.sopDetails.draftStepsJson = JSON.stringify(this.sopStepsList);
    this.sopDetails.sopInstitutions = institutionsNewList;

    // ? should this parameter will be removed?
    this.sopDetails.sopCountries = { countryID: this.layoutService.objectString(this.countryChecked) };
    if (this.sopId) {
      this.sopDetails.isSOPPuzzle = this.IsSOPPuzzle;

      this.sopDetails.updatedBy = this.userData.userId;
      if (this.checkUpdate) {
        this.sopDetails.isSubStep = (this.isDesktop) ? this.isSubprocess : this.service.subStepDisable;
      } else if (this.service.checkUpdate && !this.isDesktop) {
        this.sopDetails.isSubStep = (this.isDesktop) ? this.isSubprocess : this.service.subStepDisable;
      }
      const parsedDraftStepsJson = JSON.parse(this.sopDetails.draftStepsJson);
      if (parsedDraftStepsJson.length > 0) {
        const isSubProcess = parsedDraftStepsJson.some(el => el.stepType === true);
        this.sopDetails.isSubStep = (this.isDesktop) ? isSubProcess : this.service.subStepDisable;
      }
      this.service.updateSOP(this.sopId, this.sopDetails).subscribe((res) => {
        this.sopStepsList = JSON.parse(res.draftStepsJson);

        var step = this.sopStepsList.find(step => step.stepCount == this.sopStep.stepCount);
        if (step && step.stepCards) {
          this.sopStep.stepCards = step.stepCards;
        }

        this.layoutService.showLoader = false;
        this.childData.emit({ key: this.translationKeys.Authorization.Save });

        callback();
      }, error => {
        this.layoutService.showLoader = false;
      });
    } else {
      this.sopDetails.countryID = this.userData.roleName.roleId === 1 ? undefined : this.userData.country;
      this.sopDetails.createdBy = this.userData.userId;
      this.sopDetails.isSOPPuzzle = this.IsSOPPuzzle;
      this.sopDetails.isSubStep = (this.isDesktop) ? this.isSubprocess : this.service.subStepDisable;
      const parsedDraftStepsJson = JSON.parse(this.sopDetails.draftStepsJson);
      if (parsedDraftStepsJson.length > 0) {
        const isSubProcess = parsedDraftStepsJson.some(el => el.stepType === true);
        this.sopDetails.isSubStep = (this.isDesktop) ? isSubProcess : this.service.subStepDisable;
      }
      this.service.createSOP(this.sopDetails).subscribe((res) => {
        // this.data.showSuccess(this.layoutService.translatetext('SOP_MANAGEMENT.SUCCESSFULLY_ADDED_SOP'));
        this.layoutService.showLoader = false;
        this.childData.emit({ key: this.translationKeys.Authorization.Save });

        callback();
      }, error => {
        this.layoutService.showLoader = false;
      });
    }
  }

  validateForPublish(sopDetail: any) {

    this.resetValidations();
    let valid = true;

    // +++ validate SOP
    if (!this.modelSopTitle.value) {
      this.modelSopTitle.control.markAsDirty();
      this.modelSopTitle.control.setErrors({ invalid: true })
      this.layoutService.showError(this.layoutService.translateText('SOP_MANAGEMENT.VALIDATION.MAINTITLE'));
      valid = false;
    }
    // if(!this.modelSopDescription.value){
    //   this.modelSopDescription.control.markAsDirty();
    //   this.modelSopDescription.control.setErrors({invalid:true})
    //   this.data.showError('falta la descripcion');
    //   valid = false;
    // }

    if (!sopDetail.sopImage) {
      this.sopImageInvalid = true;
      this.layoutService.showError(this.layoutService.translateText('SOP_MANAGEMENT.VALIDATION.MAINIMAGE'));
      valid = false;
    }

    if (!this.sopStepsList || this.sopStepsList.length == 0) {
      this.layoutService.showError(this.layoutService.translateText('SOP_MANAGEMENT.VALIDATION.NOSTEPS'));
      valid = false;
    } else {
      // +++ validate steps (main info)
      this.sopStepsList.forEach(step => {
        step.isInvalid = false;
        if (!step.stepCards || step.stepCards.length == 0) {
          // something went really wrong...😂
          step.isInvalid = true;
          this.layoutService.showError(this.layoutService.translateText('SOP_MANAGEMENT.STEP') + ' ' + (step.stepOrder + 1) + this.layoutService.translateText('SOP_MANAGEMENT.VALIDATION.NOVALID'));
          valid = false;
          return;
        }
        if (!this.layoutService.translateText(step.stepName)) {
          step.invalidTitle = true;
          step.isInvalid = true;
          valid = false;
        } else {
          step.invalidTitle = false;
        }
        // validate single step / substeps (booth has stepcards)
        step.stepCards.forEach(card => {
          if (!card.stepImage) {
            step.isInvalid = true;
            card.invalidImage = true;
            valid = false;
          } else {
            card.invalidImage = false;
          }
          if (!this.layoutService.translateText(card.stepTittle)) {
            step.isInvalid = true;
            card.invalidTitle = true;
            valid = false;
          } else {
            card.invalidTitle = false;
          }
        });
        if (step.isInvalid) {
          this.layoutService.showError(this.layoutService.translateText('SOP_MANAGEMENT.STEP') + ' ' + (step.stepOrder + 1) + this.layoutService.translateText('SOP_MANAGEMENT.VALIDATION.NOVALID'));
        }
      });
    }


    if (this.roleId != 1 && this.roleId != 2 && this.checkedInstitutionIds.size == 0) {
      this.layoutService.showError(this.layoutService.translateText('LAYOUT_MODULE.SELECT_INSTITUTIONS'));
      valid = false;
    }

    return valid;

  }

  resetValidations() {
    this.modelSopTitle.control.setErrors(null);
    this.modelSopDescription.control.setErrors(null);
    this.sopImageInvalid = false;
  }

  openCancelModal(cancelmodal: TemplateRef<any>) {
    this.modalRef = this.modalService.show(cancelmodal, Object.assign({}, { class: 'w-420' })
    );
  }

  cancelSOP() {
    this.childData.emit({ key: 'cancel' });
  }

  isEditingStep: boolean = false;

  openStepEditor(index: number, offsetTop: number, offsetLeft: number, step: any, isUpdate = true) {
    // prevent switchig step when the step editor is still open
    // TODO remove old editor
    if (this.service.isCollapsed && this.isDesktop) {
      this.layoutService.showError(this.layoutService.translateText('SOP_MANAGEMENT.COMPLETE_PREVIOUS_STEP'));
      return;
    }

    if (this.isDesktop) {
      // position step editor popup
      this.stepEditorContainer.nativeElement.style.top = `${(offsetTop + 83)}px`;
      //this.stepEditorContainer.nativeElement.style.top = `${(offsetTop + 238)}px`;
      // this.stepEditorArrow.nativeElement.style.left = `${offsetLeft + 110}px`;

      // TODO remove old step editor
      const detailsDiv = document.getElementById('sopDetails');
      const pageTitleDiv = document.getElementById('title-bar');

      const x = 60 + pageTitleDiv.offsetHeight + detailsDiv.offsetHeight + offsetTop + 20 + 180;
      const y = offsetLeft;
      this.sopStepComponent.sopWrapper.nativeElement.style.top = x + 'px';
      this.sopStepComponent.sopWrapper.nativeElement.style.left = '10px';
      this.sopStepComponent.arrw.nativeElement.style.left = y + 140 + 'px';
      this.sopStepComponent.arrwShadow.nativeElement.style.left = y + 141 + 'px';
      this.sopStepComponent.isUpdate = isUpdate;
      this.sopStepComponent.selectedStepCard = index;

      // Reference to step
      this.stepRef = step;
    }
    // update data for selected sopstep
    this.sopStep = this.sopStepsList[index];
    // set selected index to show popup
    this.lastSelectedStepIndex = index;
    this.isEditingStep = true;
  }

  childEmit(event) {
    if (event && event.action === 'stepUpdate') {
      // this.selectedIndex = event.Indexkey;
      this.checkUpdate = true;
      this.isSubprocess = event.val;
      this.service.subStepDisable = event.val;
      this.triggerSaveSOP('childEmit');
    }
    switch (event.key) {
      case 'remove':
        this.removeStep(event.lastSelectedStepIndex);
        if (event.isSubStep) {
          this.service.subStepDisable = false;
        }
        break;
      case 'image':
        // TODO extract image library modal from sop step component instead of referencing it here directly
        this.sopDetails.sopImage = event.value;
        break;
      case 'userImage':
        // TODO extract image library modal from sop step component instead of referencing it here directly
        this.sopDetails.isInstitutionImage = true;
        this.sopDetails.sopImage = event.value;
        break;
      case 'saveSOP':
        this.triggerSaveSOP('childEmit');
        break;
      case 'cancelImage':
        this.sopDetails.sopImage = this.previousImage;
        break;
      case 'stepImage':
        this.sopStepsList[this.lastSelectedStepIndex].stepImage = event.value;
        this.sopStepsList[this.lastSelectedStepIndex].stepCards[event.stepIndex].stepImage = event.value;
        break;
    }
  }

  openDeleteModal(deletemodal: TemplateRef<any>, dataItem = null) {
    // this.deleteDataItem = dataItem
    this.modalRef = this.modalService.show(deletemodal, Object.assign({}, { class: 'w-420' })
    );
  }

  PreViewSOP() {
    // convert to (old) format (Object with ids as field key and boolean value to indicate "checked")
    const institutionChecked: { [instId: string]: boolean; } = {};
    this.checkedInstitutionIds.forEach(id => institutionChecked[id] = true);

    const initialState = {
      sopId: this.sopId,
      userData: this.userData
    };
    if (this.isDesktop) {
      this.modalRef = this.modalService.show(PhBhpViewSOPComponent, { initialState, class: 'modal-full w-full' });
    } else {
      this.childData.emit({ key: 'preview', data: initialState });
    }
  }

  deleteImage() {
    this.sopDetails.sopImage = null;

    this.triggerSaveSOP();
  }

  editImage() {
    this.previousImage = this.sopDetails.sopImage;
    // TODO extract image library modal from sop step component instead of referencing it here directly
    if (this.blockCAChanges) return;
    this.sopImageInvalid = false;
    this.sopStepComponent.openModal(null);
  }

  openTranslationModal(key: string, fieldName: string, isMultiLine = false, maxlength: number = 150) {
    if (this.blockCAChanges) return;
    this.layoutService.showLoader = true;
    const subscription = this.service.getTranslationsFromKey(key).subscribe((result: { language: string, value: string }) => {
      const modalRef = openTranslationModal(this.modalService, key, result, fieldName, isMultiLine, maxlength);
      this.layoutService.showLoader = false;
      modalRef.content.subject$.subscribe((data: ChangedTranslationValue[]) => {
        if (data.findIndex(e => e.language == 'en') === -1 && data.length > 0) {
          data.push({
            language: 'en',
            value: data[0].value
          });
        }
        const request = {};
        for (let index = 0; index < data.length; index++) {
          request[data[index].language] = data[index].value;
          const langs = this.translate.getLangs();
          if (langs.indexOf(data[index].language) >= 0) {
            this.translate.set(key, data[index].value, data[index].language);
          }
        }

        if (data && data.length > 0) {
          // check connection
          // retry

          if (navigator.onLine) {
            this.service.patchTranslation(key, request).subscribe(() => {
            }, err => {
              this.logging.logError(err.message, err);
              this.layoutService.showLoader = false;
            });
          } else {
            let intent = 0;
            this.layoutService.showLoader = true;
            let id = setInterval(() => {
              if (navigator.onLine) {
                this.service.patchTranslation(key, request).subscribe(() => {
                  clearInterval(id);
                  this.layoutService.showLoader = false;
                }, err => {
                  clearInterval(id);
                  this.logging.logError(err.message, err);
                  this.layoutService.showLoader = false;
                  if (navigator.onLine) {
                    this.layoutService.showError(this.layoutService.translateText(this.translationKeys.SOPManagement.SOPTrlUpdateError));
                  } else {
                    clearInterval(id);
                    this.layoutService.showError(this.layoutService.translateText(this.translationKeys.SOPManagement.SOPTrlUpdateNoConnection));
                  }
                });
              }
              if (intent == 3) {
                clearInterval(id);
                this.layoutService.showError(this.layoutService.translateText(this.translationKeys.SOPManagement.SOPTrlUpdateLimitIntent));
                this.logging.logError('third attempt to save translations unsuccess');
                this.layoutService.showLoader = false;
                return;
              }
              intent++;
              console.log('retry ' + intent + ', wait 2 seconds')
            }, 2 * 1000);
          }
        }
      }, error => {
        this.logging.logError(error.message, error);
        this.layoutService.showLoader = false;
      });
    }, error => {
      this.logging.logError(error.message, error);
      this.layoutService.showLoader = false;
    });
  }

  checkPuzzle() {
    this.triggerSaveSOP('checkPuzzle');
  }

  triggerSaveSOP(value?: string) {
    this.layoutService.showLoader = true;
    this.saveDebouncer.next(value);
  }

  async addStep(stepIndex: number | 'atEnd') {
    try {
      // collapse editor view
      this.closeStepEditorPopup();

      this.layoutService.showLoader = true;

      // generate a new empty step
      const newSop = sop();

      if (stepIndex === 'atEnd') {
        // step should be added at end
        stepIndex = this.sopStepsList.length;
      }

      // update step list
      this.sopStepsList.splice(stepIndex, 0, newSop);

      // save to synchronize with backend
      await this.saveSOPPromise();

      // regenerate keys for new step card order, because we added / removed steps
      await this.refreshDynamicTranslations();
    } catch (e) {
      this.logging.logError(e.message, e)
    } finally {
      this.layoutService.showLoader = false;
    }
  }

  async removeStep(stepIndex: number) {
    try {
      // collapse editor view
      this.closeStepEditorPopup();

      this.layoutService.showLoader = true;

      var deletedCard = this.sopStepsList[stepIndex];
      this.translate.set(deletedCard.stepName, null);
      this.translate.set(deletedCard.stepCards[0].stepTittle, null);
      this.translate.set(deletedCard.stepCards[0].comments, null);

      // update step list
      this.sopStepsList.splice(stepIndex, 1);

      // save to synchronize with backend
      await this.saveSOPPromise();

      // regenerate keys for new step card order, because we added / removed steps
      await this.refreshDynamicTranslations();
    } catch (e) {
      this.logging.logError(e.message, e)
    } finally {
      this.layoutService.showLoader = false;
    }
  }

  /**
   * Update selected institutions and trigger saving SOP
   */
  checkedInstitutionIdsChanged(selectedInstitutionIds: number[]) {
    // show validation error when no institutions are selected
    this.institutionIsChecked = selectedInstitutionIds.length > 0;

    this.checkedInstitutionIds = new Set(selectedInstitutionIds);

    this.triggerSaveSOP();
  }

  removeImageForCurrentStepForSubStepIndex(subStepIndex: number) {
    this.sopStep.stepCards[subStepIndex].stepImage = null;

    this.triggerSaveSOP();
  }

  setImageForCurrentStepForSubStepIndex(subStepIndex: number) {
    // TODO extract image library modal from sop step component instead of referencing it here directly
    this.sopStepComponent.openModal(subStepIndex);
  }

  changeSituationalTextForSubStepIndex(subStepIndex: number) {
    // TODO consider moving this to shared component / implementation and using directly in all sub components
    this.openTranslationModal(
      this.sopStep.stepCards[subStepIndex].comments,
      'CONFIGURE.COMMENTS',
      true,
      500);
  }

  changeTitleForSubStepIndex(subStepIndex: number) {
    // TODO consider moving this to shared component / implementation and using directly in all sub components
    this.openTranslationModal(
      this.sopStep.stepCards[subStepIndex].stepTittle,
      'SOP_MANAGEMENT.STEP_TITLE',
      false,
      200);
  }

  changeStepTitle() {
    // TODO consider moving this to shared component / implementation and using directly in all sub components
    this.openTranslationModal(
      this.sopStep.stepName,
      'SOP_MANAGEMENT.TITLE_SUB_PROCESS',
      false,
      200);
  }

  setSituationalForSubStepIndex(subStepIndex: number, value: boolean) {
    this.sopStep.stepCards[subStepIndex].situational = value;

    this.triggerSaveSOP();
  }

  setIndicationsForSubStepIndex(subStepIndex: number, value: StepIndications) {
    this.sopStep.stepCards[subStepIndex].handDisinfection = value.hasHandDisinfection;
    this.sopStep.stepCards[subStepIndex].indications = {
      1: value.hasIndication1,
      2: value.hasIndication2,
      3: value.hasIndication3,
      4: value.hasIndication4,
      5: value.hasIndication5
    }

    this.triggerSaveSOP();
  }

  setHygieneRelevantForSubStepIndex(subStepIndex: number, value: boolean) {
    this.sopStep.stepCards[subStepIndex].hygieneRelevantStep = value;

    this.triggerSaveSOP();
  }

  async deleteStep() {
    await this.removeStep(this.lastSelectedStepIndex);
  }

  async deleteSubStep(subStepIndex: number) {
    var deletedCard = this.sopStep.stepCards[subStepIndex];
    this.translate.set(deletedCard.stepTittle, null);
    this.translate.set(deletedCard.comments, null);
    this.sopStep.stepCards.splice(subStepIndex, 1);

    // copy to update reference to force Angular update
    this.sopStep.stepCards = [...this.sopStep.stepCards];

    if (this.sopStep.stepCards.length == 1) {
      // if only single sub step is left, change this into a "single step" instead of sub-process
      this.sopStep.stepType = false;
    }

    // update step with stepCards
    var step = this.sopStepsList.find(step => step.stepCount == this.sopStep.stepCount);
    step.stepCards = this.sopStep.stepCards;

    // save to synchronize with backend
    await this.saveSOPPromise();

    // regenerate keys for new step card order, because we added / removed steps
    await this.refreshDynamicTranslations();
  }

  closeStepEditorPopup() {
    this.lastSelectedStepIndex = null;
  }

  async setSubProcess(enable: boolean) {
    if (enable) {
      if (this.sopStep.stepCards.length <= 1) {
        // if we change from single step to sub process, we add an empty step, so that there are at least 2.
        // await this.addStep('atEnd');
        this.sopStep.stepCards.push(stepCards());
        this.sopStep.stepType = true;
      }
    } else {
      // if we change from process to single step, we only retain the first step
      this.sopStep.stepCards = [this.sopStep.stepCards[0]];
      this.sopStep.stepType = false;
    }
    this.sopStepsList[this.sopStepsList.findIndex(step => step.stepId == this.sopStep.stepId)].stepType = this.sopStep.stepType;

    // save to synchronize with backend
    await this.saveSOPPromise();

    // regenerate keys for new step card order, because we added / removed steps
    await this.refreshDynamicTranslations();
  }

  async addSubStep() {
    if (!this.sopStep.stepType) {
      // can only add sub steps to type "sub process"
      return;
    }

    this.sopStep.stepCards = [...this.sopStep.stepCards, stepCards()];

    // update step with stepCards
    var step = this.sopStepsList.find(step => step.stepCount == this.sopStep.stepCount);
    step.stepCards = this.sopStep.stepCards;

    // save to synchronize with backend
    await this.saveSOPPromise();

    // regenerate keys for new step card order, because we added / removed steps
    await this.refreshDynamicTranslations();
  }

  setDefaultStepImage(stepIndex: number) {
    if (!this.sopStep.stepType) {
      // can only set default image for type "sub process"
      return;
    }

    this.sopStep.useStepImage = stepIndex;
    this.sopStepsList[this.lastSelectedStepIndex].useStepImage = stepIndex;

    this.triggerSaveSOP();
  }

  setValidatedFields(card) {
    if (card) {
      // TODO workaround for edit the info into parent (and returned to this component...)
      let step = this.sopStep.stepCards.find(s => s.stepTittle == card.title);
      if (step) {
        step.invalidTitle = card.invalidTitle;
        step.invalidImage = card.invalidImage;
      }
    }
  }

  private async loadTranslationsForSOP() {
    // Get newly created Translations in case of Duplication of this SOP
    const translations = await this.service.getTranslationsForSop(this.sopId, this.sopVersionNo).toPromise();

    // list of already loaded languages. We cannot set values for languages that where never loaded.
    // However, we don't need to anyway, since they will be refreshed once they are loaded.
    const loadedLanguages = this.translate.getLangs();
    for (const language in translations) {
      if (!loadedLanguages.includes(language)) {
        continue;
      }

      const entries = translations[language];
      for (const key in entries) {
        const value = entries[key];
        // ignore if key is somehow invalid or value is null or empty string
        if (key && value) {
          this.translate.set(key, value, language);
        }
      }
    }
  }

  /**
   * Save SOP to server immediately.
   */
  private async saveSOPPromise(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.saveSOP();
    });
  }

  private generateSopStepKey(stepIndex: number, field: string): string {
    return `SOP_${this.sopId}_${this.sopVersionNo}.STEPS.STEP_${stepIndex}.${field}`;
  }

  private generateSopSubStepKey(stepIndex: number, subStepIndex: number, field: string): string {
    return `SOP_${this.sopId}_${this.sopVersionNo}.STEPS.STEP_${stepIndex}.SUBSTEPS.STEP_${subStepIndex}.${field}`;
  }


  /**
   * Updates correct translation keys for each step / substep field.
   *
   * Use this to fix synchronization issues with translations after changing the SOP structure.
   */
  private async refreshDynamicTranslations() {
    // reload all currently loaded language to replace keys with the correct values
    // technically we only need to reload the values for the current SOP, but ngx-translate does not provide
    // a usable API to iterate loaded values. Since we are moving indices when adding / removing steps, there are
    // many instances where another step occupies the values of a previous step and there is no easy way to detect
    // this.
    // TODO consider doing translations NOT via ngx-translate inside the SOP editor as creates a
    //  lot of difficulties when synchronizing values.
    this.layoutService.showLoader = true;
    await Promise.all(
      this.translate.getLangs().map(lang =>
        this.translate
          .reloadLang(lang)
          .toPromise()));

    // regenerate all fields with translation key in the steps to make sure all values are set correctly
    const steps = this.sopStepsList;

    // iterate through elements and generate all translation keys
    this.sopStepsList.forEach(step => {
      step.stepName = this.generateSopStepKey(+step.stepCount, 'TITLE');

      step.stepCards.forEach(subStep => {
        if (step.stepType) {
          // is sub process / has sub steps
          subStep.stepTittle = this.generateSopSubStepKey(+step.stepCount, subStep.subStepCount, 'TITLE');
          subStep.comments = this.generateSopSubStepKey(+step.stepCount, subStep.subStepCount, 'COMMENT');
        } else {
          subStep.stepTittle = this.generateSopStepKey(+step.stepCount, 'TITLE');
          subStep.comments = this.generateSopStepKey(+step.stepCount, 'COMMENT');
        }
      });
    });
    this.layoutService.showLoader = false;
  }

  errImg(e: Event) {
    e.target['src'] = 'assets/img/fallback-img.png';
  }

  onFocusOutSOPInput(event: any, key: string) {
    var newValue = event.target.value;
    this.service.getTranslationsFromKey(key).subscribe((result: { language: string, value: string }) => {
      var currentLanguage = this.translate.currentLang;
      if (result['en'] == '' || result['en'] == null) {
        result['en'] = newValue;
        this.translate.set(key, newValue, 'en');
      }

      result[currentLanguage] = newValue;
      this.service.patchTranslation(key, result).subscribe(() => {
        this.translate.set(key, newValue, currentLanguage);
      });
    });
  }
}

interface PublishedSopTranslation {
  [language: string]: SopLanguageKeys;
}

interface SopLanguageKeys {
  [key: string]: string;
}
